import { render, staticRenderFns } from "./cemento.vue?vue&type=template&id=171e82bd&"
import script from "./cemento.vue?vue&type=script&lang=js&"
export * from "./cemento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports